import { AutoComplete, Input, Select } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getFacultySuggestSearch } from "Benchmarking/Services/Author";
import { getInstitutionSuggestSearch } from "Benchmarking/Services/Institution";
const NavbarSearch = ({ searchDefault, setSearchDefault }) => {
  const navigate = useNavigate();
  const [facultySuggest, setFacultySuggest] = useState([]);
  const [institutionSuggest, setInstitutionSuggest] = useState([]);

  const renderTitle = (title) => <span>{title}</span>;

  const renderFaculty = (item) => ({
    value: item.name,
    entity: "faculty",
    id: item.id,
    label: (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
        onClick={() => {
          navigate(`/benchmarking/faculty/profile/${item.id}`);
          window.location.reload();
        }}
      >
        {item.name}
      </div>
    ),
  });

  const renderInstitution = (item) => ({
    value: item.name,
    entity: "institution",
    id: item.id,
    label: (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
        onClick={() => {
          navigate(`/benchmarking/institution/profile/${item.id}`);
          window.location.reload();
        }}
      >
        {item.name}
      </div>
    ),
  });

  let options;
  if (searchDefault == "all") {
    options = [
      {
        label: renderTitle("Faculty"),
        options: facultySuggest.map((item) => renderFaculty(item)),
      },
      {
        label: renderTitle("Institution"),
        options: institutionSuggest.map((item) => renderInstitution(item)),
      },
    ];
  } else if (searchDefault == "faculty") {
    options = facultySuggest.map((item) => renderFaculty(item));
  } else if (searchDefault == "institution") {
    options = institutionSuggest.map((item) => renderInstitution(item));
  }

  const handleChangeSearch = (value) => {
    setSearchDefault(value);
  };
  const handleSelectItem = (value, option) => {
    navigate(`/benchmarking/${option.entity}/profile/${option.id}`);
    window.location.reload();
  };

  const handleInputChange = (value) => {
    if ((searchDefault == "all") & (value !== "")) {
      getFacultySuggestSearch(value, (res) => {
        setFacultySuggest(res.slice(0, 3));
      });
      getInstitutionSuggestSearch(value, (res) => {
        setInstitutionSuggest(res.slice(0, 3));
      });
    } else if ((searchDefault == "faculty") & (value !== "")) {
      getFacultySuggestSearch(value, (res) => {
        setFacultySuggest(res);
      });
    } else if ((searchDefault == "institution") & (value !== "")) {
      getInstitutionSuggestSearch(value, (res) => {
        setInstitutionSuggest(res);
      });
    }
  };
  return (
    <div className="search">
      <div className="search-bar">
        <AutoComplete
          popupClassName="certain-category-search-dropdown"
          popupMatchSelectWidth="100%"
          options={options}
          onChange={handleInputChange}
          onSelect={handleSelectItem}
        >
          <Input placeholder="Type to search" className="input-search" />
        </AutoComplete>
      </div>

      <Select
        value={searchDefault}
        placeholder="Borderless"
        variant="borderless"
        style={{
          flex: 1,
        }}
        onChange={handleChangeSearch}
        options={[
          {
            value: "all",
            label: "All",
          },
          {
            value: "faculty",
            label: "Faculty",
          },
          {
            value: "institution",
            label: "Institution",
          },
        ]}
      />
    </div>
  );
};

export default NavbarSearch;
